var map = {
	"./bounce/blocks": 2216,
	"./calc/blocks": 2217,
	"./craft/agent/blocks": 2219,
	"./craft/code-connection/blocks": 2220,
	"./craft/designer/blocks": 2075,
	"./craft/simple/blocks": 2218,
	"./dance/blocks": 1666,
	"./eval/blocks": 2221,
	"./flappy/blocks": 2222,
	"./jigsaw/blocks": 2228,
	"./maze/blocks": 2229,
	"./p5lab/spritelab/blocks": 1252,
	"./sites/studio/pages/blocks": 2245,
	"./studio/blocks": 2084,
	"./turtle/blocks": 2241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2668;